/**
 * The write floor for a resolved file permission (`owner` / `admin` /
 * `readwrite` / `readcopy` / `hidden` / `none`): only the first three may write
 * — the server's own rule. One definition for every client surface that asks
 * "is this editable", so a read-only decision can't drift between them (#942).
 */
export function canWriteFor(permission: string | undefined | null): boolean {
  return permission === 'readwrite' || permission === 'admin' || permission === 'owner'
}
